import React, { useEffect, useState } from 'react';
import axios from 'axios';

const SellerManage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [focusedField, setFocusedField] = useState('');

  useEffect(() => {
    const checkSellerAuth = async () => {
      try {
        const res = await axios.get('/api/seller/auth/me', {
          withCredentials: true,
        });

        if (res.data && res.data.is_seller === true) {
          window.location.href = res.data.redirect || '/seller/';
          return;
        }
      } catch (err) {
        console.error('셀러 로그인 상태 확인 실패:', err);
      } finally {
        setChecking(false);
      }
    };

    checkSellerAuth();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting) return;

    setError('');

    try {
      setSubmitting(true);

      const res = await axios.post(
        '/api/seller/login_process',
        {
          username,
          password,
        },
        {
          withCredentials: true,
        }
      );

      if (res.data && res.data.ok) {
        window.location.href = res.data.redirect || '/seller/';
        return;
      }

      setError('아이디 또는 비밀번호가 올바르지 않습니다.');
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        '아이디 또는 비밀번호가 올바르지 않습니다.';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (checking) {
    return (
      <div style={styles.page}>
        <div style={styles.modalWrap}>
          <div style={styles.modalContent}>
            <div style={styles.body}>
              <div style={styles.loadingText}>로딩중...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const usernameActive = focusedField === 'username' || username !== '';
  const passwordActive = focusedField === 'password' || password !== '';

  return (
    <div style={styles.page}>
      <div style={styles.modalWrap}>
        <div style={styles.modalContent}>
          <div style={styles.header}>
            <h1 style={styles.title}>셀러 로그인</h1>
          </div>

          <div style={styles.body}>
            <form onSubmit={handleSubmit}>
              {error ? <div style={styles.alertDanger}>{error}</div> : null}

              <div style={styles.formFloating}>
                <input
                  type="text"
                  name="username"
                  id="floatingInput"
                  placeholder=""
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onFocus={() => setFocusedField('username')}
                  onBlur={() => setFocusedField('')}
                  style={{
                    ...styles.input,
                    ...(focusedField === 'username' ? styles.inputFocus : {}),
                  }}
                  autoComplete="username"
                />
                <label
                  htmlFor="floatingInput"
                  style={{
                    ...styles.label,
                    ...(usernameActive ? styles.labelActive : {}),
                  }}
                >
                  아이디
                </label>
              </div>

              <div style={styles.formFloating}>
                <input
                  type="password"
                  name="password"
                  id="floatingPassword"
                  placeholder=""
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setFocusedField('password')}
                  onBlur={() => setFocusedField('')}
                  style={{
                    ...styles.input,
                    ...(focusedField === 'password' ? styles.inputFocus : {}),
                  }}
                  autoComplete="current-password"
                />
                <label
                  htmlFor="floatingPassword"
                  style={{
                    ...styles.label,
                    ...(passwordActive ? styles.labelActive : {}),
                  }}
                >
                  패스워드
                </label>
              </div>

              <button
                style={styles.submitButton}
                type="submit"
                disabled={submitting}
              >
                {submitting ? '로그인 중...' : '로그인'}
              </button>

              <small style={styles.smallText}></small>
              <p style={styles.copyright}>&copy; 2025</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: '#6c757d',
    padding: '48px 16px',
    fontFamily: "'Noto Sans KR', sans-serif",
    boxSizing: 'border-box',
  },
  modalWrap: {
    minHeight: 'calc(100vh - 96px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    width: '100%',
    maxWidth: '500px',
    background: '#fff',
    borderRadius: '0.25rem',
    boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
    overflow: 'hidden',
  },
  header: {
    padding: '3rem 3rem 1rem 3rem',
    borderBottom: '0',
  },
  title: {
    margin: 0,
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#212529',
  },
  body: {
    padding: '0 3rem 3rem 3rem',
  },
  formFloating: {
    position: 'relative',
    marginBottom: '1rem',
  },
  input: {
    width: '100%',
    height: '58px',
    padding: '1.625rem 0.75rem 0.625rem 0.75rem',
    fontSize: '1rem',
    lineHeight: 1.25,
    color: '#212529',
    backgroundColor: '#fff',
    border: '1px solid #ced4da',
    borderRadius: '0.3rem',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',
  },
  inputFocus: {
    borderColor: '#86b7fe',
    boxShadow: '0 0 0 0.25rem rgba(13,110,253,.25)',
  },
  label: {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '100%',
    padding: '1rem 0.75rem',
    color: '#6c757d',
    pointerEvents: 'none',
    transformOrigin: '0 0',
    fontSize: '1rem',
    lineHeight: 1.25,
    boxSizing: 'border-box',
    transition: 'all .1s ease-in-out',
    display: 'flex',
    alignItems: 'center',
  },
  labelActive: {
    height: 'auto',
    padding: '0.35rem 0.75rem 0 0.75rem',
    transform: 'scale(.85) translateY(-0.35rem)',
    opacity: 0.65,
    alignItems: 'flex-start',
  },
  submitButton: {
    width: '100%',
    marginBottom: '0.5rem',
    padding: '0.75rem 1rem',
    fontSize: '1.25rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#fff',
    backgroundColor: '#0d6efd',
    border: '1px solid #0d6efd',
    borderRadius: '0.25rem',
    cursor: 'pointer',
  },
  smallText: {
    color: '#6c757d',
  },
  copyright: {
    marginTop: '3rem',
    marginBottom: '1rem',
    color: '#6c757d',
    fontSize: '1rem',
  },
  alertDanger: {
    padding: '0.75rem 1rem',
    marginBottom: '1rem',
    border: '1px solid #f5c2c7',
    borderRadius: '0.25rem',
    background: '#f8d7da',
    color: '#842029',
    fontSize: '0.95rem',
  },
  loadingText: {
    textAlign: 'center',
    color: '#6c757d',
    padding: '2rem 0',
  },
};

export default SellerManage;